

import { useState } from "react";
import { X } from "lucide-react";
import axios from "axios";
import Cookies from "js-cookie";
import { createPortal } from "react-dom";

export default function AddItemType({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    item_type: "",
    user_assignable: false,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((p) => ({
      ...p,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const token = Cookies.get("token");

      const res = await axios.post(
        "https://uptask.visiontrek.io/api/inventory/types",
        // "https://192.168.1.16:5555/api/inventory/types",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (res.data?.success) {
        onClose();
        setFormData({ item_type: "", user_assignable: false });
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to add item type");
    } finally {
      setLoading(false);
    }
  };

if (!isOpen) return null;

return createPortal(
  <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-[9999]">
    <div className="
      relative z-[10000]
      w-full max-w-md rounded-2xl
      bg-white/15 backdrop-blur-xl
      shadow-2xl border border-white/20
      text-white
    ">

      {/* Header */}
      <div className="
        flex items-center justify-between px-6 py-4
        rounded-t-2xl
        bg-gradient-to-r from-[#2d1c6a] to-[#24155a]
      ">
        <h2 className="text-lg font-semibold">
          Add Item Type
        </h2>
        <X
          size={20}
          onClick={onClose}
          className="cursor-pointer text-white/90 hover:text-red-300"
        />
      </div>

      {/* Body */}
      <form onSubmit={handleSubmit} className="p-6 space-y-5">
        {error && (
          <div className="bg-red-500/20 text-red-300 p-3 rounded text-sm">
            {error}
          </div>
        )}

        <div>
          <label className="text-sm text-white/80">
            Item Type *
          </label>
          <input
            name="item_type"
            value={formData.item_type}
            onChange={handleChange}
            required
            className="
              w-full mt-1 px-3 py-2 rounded-lg
              bg-white/10 border border-white/20
              placeholder-white/50
              focus:outline-none focus:ring-2 focus:ring-purple-400
            "
            placeholder="Laptop, Mouse, Printer..."
          />
        </div>

        <div className="flex items-center gap-3">
          <input
            type="checkbox"
            name="user_assignable"
            checked={formData.user_assignable}
            onChange={handleChange}
            className="accent-purple-500"
          />
          <span className="text-sm text-white/80">
            User Assignable
          </span>
        </div>

        {/* Actions */}
        <div className="flex justify-end gap-3 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded bg-white/10 hover:bg-white/20"
          >
            Cancel
          </button>

          <button
            type="submit"
            disabled={loading}
            className="px-5 py-2 rounded bg-purple-600 hover:bg-purple-500"
          >
            {loading ? "Adding..." : "Add Type"}
          </button>
        </div>
      </form>
    </div>
  </div>,
  document.body
);

}
